module.exports = __webpack_public_path__ + "static/media/4XL.6bd6c1e4.jpg";